module.exports = __webpack_public_path__ + "img/why-3.e3f8ef04.png";